module.exports = __webpack_public_path__ + "media/img/auth/auth-corporate-dcb1b93a36e6001bd87f6f8086bbdf37.jpg";